import HomePageHeader from "../../components/HomePageHeader";
import HomePageSearchBar from "../../components/HomePageSearchBar";
import HomePageFooter from "../../components/HomePageFooter";
import { UserNavigator } from "../../components/UserNavigator";
import UserOrderList from "../../components/UserOrderList";
import styles from "./userorderlistpage.module.css";
export default function UserOrderListPage() {
  return (
    <div className={`container-fluid h-custom ${styles.page}`}>
      <div className="row Header">
        <HomePageHeader />
        <HomePageSearchBar />
      </div>
      <div className="row Body">
        <div className="col-3 px-0">
          <UserNavigator />
        </div>
        <div className={`col-9 ${styles.userOrderList}`}>
          <UserOrderList />
        </div>
      </div>
      <div className="row footer">
        <HomePageFooter />
      </div>
    </div>
  );
}
